import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { AppBar, Toolbar } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';
import React from 'react'; // ----------------------------------------------------------------------

var APPBAR_HEIGHT = 56;
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      zIndex: function zIndex(props) {
        return props.zIndex || 999;
      },
      backdropFilter: 'blur(8px)',
      boxShadow: theme.shadows[25].z8,
      color: theme.palette.text.primary,
      backgroundColor: alpha(theme.palette.background.default, 0.72)
    }, theme.breakpoints.up('md'), {
      zIndex: function zIndex(props) {
        return props.zIndexUpMd || 1999;
      }
    }),
    toolbar: {
      minHeight: APPBAR_HEIGHT
    }
  };
});
export var EditorHeader = function EditorHeader(_ref) {
  var styles = _ref.styles,
      children = _ref.children;
  var classes = useStyles(styles);
  return React.createElement(AppBar, {
    className: classes.root
  }, React.createElement(Toolbar, {
    className: classes.toolbar
  }, children));
};